import React, { createContext, useContext, useState, useCallback } from 'react';

const TutorialContext = createContext(null);

export const TutorialProvider = ({ children }) => {
  const [isRunning, setIsRunning] = useState(false);
  const [stepIndex, setStepIndex] = useState(0);

  const startTutorial = useCallback(() => {
    setStepIndex(0);
    setIsRunning(true);
  }, []);

  const stopTutorial = useCallback(() => {
    setIsRunning(false);
    setStepIndex(0);
  }, []);

  const nextStep = useCallback(() => {
    setStepIndex(prev => prev + 1);
  }, []);

  const prevStep = useCallback(() => {
    setStepIndex(prev => Math.max(0, prev - 1));
  }, []);

  const goToStep = useCallback((index) => {
    setStepIndex(index);
  }, []);

  const value = {
    isRunning,
    stepIndex,
    startTutorial,
    stopTutorial,
    nextStep,
    prevStep,
    goToStep,
    setStepIndex,
    setIsRunning
  };

  return (
    <TutorialContext.Provider value={value}>
      {children}
    </TutorialContext.Provider>
  );
};

export const useTutorial = () => {
  const context = useContext(TutorialContext);
  if (!context) {
    throw new Error('useTutorial must be used within a TutorialProvider');
  }
  return context;
};

export default TutorialContext;
